export class AlertBanner {
    constructor() {
        const closeButton = document.getElementById("hide-banner") as HTMLButtonElement | null;

        if (!closeButton) return;

        closeButton.addEventListener("click", (e: MouseEvent) => {
            const banner = document.getElementById("site-banner") as HTMLElement | null;
            if (!banner) return;

            banner.classList.add("visually-hidden");

            const cookieContent = banner.getAttribute("date-updated");

            if (cookieContent) {
                setCookie(cookieContent);
            }
        });
    }
}

function setCookie(guid: string): void {
    const cName = "site_alert_banner";
    const expires = new Date();
    expires.setDate(expires.getDate() + 1);

    const cookie = `${cName}=${guid}; expires=${expires.toUTCString()}; path=/`;

    document.cookie = cookie;
}
